import Error from "@material-ui/icons/Error";
import styled from 'styled-components';
import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';
import { Container, Flex, Text } from 'rebass';

const ErrorIcon = styled(Error)`
  color: ${(props) => props.theme.colors.red}
  font-size: 32px !important;
  margin-right: 5px;
`;

// Component to show errors thrown by child components..instead of crashing the whole app
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({hasError: true});
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container mt={4}>
          <Flex>
            <ErrorIcon />
            <Text f={5}><Translate value='app.react_error' /></Text>
          </Flex>
        </Container>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;


// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.jsx